import { DEPLOYMENT_STATUS, HARDWARE, ROUTES } from 'vio-constants';
export function isChamber(deployedHardware) {
    return deployedHardware.includes(HARDWARE.CHAMBER);
}
export function isHardwareNetworkOnly(deployedHardware) {
    return deployedHardware === HARDWARE.EDGE_NETWORK_ONLY;
}
export function isNetworkingView(pathname) {
    return pathname.includes(ROUTES.NETWORKING);
}
export function isOnline(deploymentStatus) {
    return deploymentStatus === DEPLOYMENT_STATUS.ONLINE;
}
export function isRacksView(pathname) {
    return pathname.includes(ROUTES.RACKS);
}
export function isShelterRetrofit(deployedHardware) {
    return deployedHardware === HARDWARE.SHELTER_RETROFIT;
}
export function isVEM(deployedHardware) {
    return deployedHardware.includes(HARDWARE.VEM);
}
export function isVEM150A2(deployedHardware) {
    const hardware = deployedHardware && deployedHardware.toUpperCase();
    return hardware === HARDWARE.VEM150A2 || hardware === HARDWARE.VEM;
}
export function isVEM180(deployedHardware) {
    const hardware = deployedHardware && deployedHardware.toUpperCase();
    return hardware ? hardware.includes(HARDWARE.VEM180) : false;
}
export function isVEM180A1(deployedHardware) {
    const hardware = deployedHardware && deployedHardware.toUpperCase();
    return hardware === HARDWARE.VEM180A1;
}
export function isVEM180A2(deployedHardware) {
    const hardware = deployedHardware && deployedHardware.toUpperCase();
    return hardware === HARDWARE.VEM180A2;
}
export function isVEM20(deployedHardware) {
    const hardware = deployedHardware && deployedHardware.toUpperCase();
    return hardware ? hardware.includes(HARDWARE.VEM20) : false;
}
export function isVEM20A1(deployedHardware) {
    const hardware = deployedHardware && deployedHardware.toUpperCase();
    return hardware === HARDWARE.VEM20A1;
}
export function isVEM20A2(deployedHardware) {
    const hardware = deployedHardware && deployedHardware.toUpperCase();
    return hardware === HARDWARE.VEM20A2;
}
